import InputBordered from '../InputBordered';
import { useState, useEffect } from 'react';
import useDidMountEffect from '../../utils/useDidMountEffect';
import { connect, useDispatch } from 'react-redux';
import { getCategories, resetCategories, setAlert, setCategories } from '../../../redux/actions';

const Form = ({
    category,
    setCategory,
    setShowForm,
    categories,
}) => {
    const maxChars = 64;

    const dispatch = useDispatch();

    const [errors, setErrors] = useState('');
    const [name, setName] = useState('');
    const [busy, setBusy] = useState(false);

    const handleCategoryChange = (e) => {
        e.preventDefault();
        const value = e.target.value;

        if (value.length <= maxChars) {
            setName(value);
        }
    };

    useDidMountEffect(() => {
        if (!name) {
            setErrors('Please enter a valid wall album name');
        } else {
            setErrors('');
        }
    }, [name]);

    useEffect(() => {
        if (category && Object.keys(category).length > 0) {
            setName(category.name);
        }
    }, []);

    const handleCancel = () => {
        setShowForm(false);
    };

    const handleSave = async () => {
        if (!name) {
            setErrors('Please enter a valid wall album name');
            return;
        } else {
            setErrors('');
        }

        setBusy(true);
        const params = {
            name
        };
        const isUpdate = category && Object.keys(category).length > 0;
        const request = isUpdate
            ? axios.patch(`/api/categories/${category.id}`, params)
            : axios.post('/api/categories', params);

        request.then(response => {
            dispatch(setAlert({
                show: true,
                body: 'Successfully created a wall album'
            }));

            let tmp = [...categories];
            const index = tmp.findIndex(t => t.id === category.id);

            if (isUpdate && index >= 0) {
                tmp[index].name = name;
                dispatch(setCategories(tmp));
            } else {
                dispatch(resetCategories());
                dispatch(getCategories({
                    perPage: 15,
                    categoriesLn: 0
                }));
            }

            setName('');
            setBusy(false);
            setShowForm(false);

            setCategory({});
        })
            .catch(error => {
                console.error({ error });
                setBusy(false);
                dispatch(setAlert({
                    show: true,
                    body: `Failed to create wall album.Please contact support <a href="https://priva.uvdesk.com/en/" target="_blank">here</a>.`
                }));
            });
    };

    useEffect(() => {
        if (category && Object.keys(category).length > 0) {
            setName(category.name);
        }
    }, [category]);


    return <div>
        <InputBordered
            label="Wall Album Name"
            type="text"
            value={name}
            containerClass={`post-wall-album-form-container mx-2 category__form${errors ? ' has-error' : ''}`}
            onChange={handleCategoryChange}
        />
        <div className="category__max-chars text-right mb-2">
            {name.length}/{maxChars}
        </div>

        <div className="mt-2 text-right">
            <button
                className='btn btn-light btn-sm mx-2'
                onClick={handleCancel}
            >Cancel</button>
            {
                errors || busy
                    ? <button
                        className='btn btn-primary btn-sm mx-2'
                        disabled
                    >
                        {category && Object.keys(category).length > 0 ? 'Update' : 'Create'}
                    </button>
                    : <button
                        className='btn btn-primary btn-sm mx-2'
                        onClick={handleSave}
                    >
                        {category && Object.keys(category).length > 0 ? 'Update' : 'Create'}
                    </button>
            }
        </div>
    </div>;
};

const mapStateToProps = (state) => {
    return {
        categories: state.category.categories
    };
};

export default connect(mapStateToProps)(Form);
